import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useAllDistributors = () => useQuery({ queryKey: ['all-distributors'], queryFn: async () => {
    const callback = await API.get(`/common/distributors`)
    return callback?.data
},staleTime: 1000 * 60 * 60, gcTime: 1000 * 60 * 60 * 24 })

export default useAllDistributors